import React, { useEffect, useState } from 'react'
import AuthLayout from '../../layouts/AuthLayout'
import MobileView from '../../layouts/MobileView/MobileView'
import { fetchIGHandleVerificationStatus } from '../../services/api/auth'
import ifAuthenticated from '../../utils/hoc/ifAuthenticated'
import { copyToClipboard } from '../../utils/helpers'
import { useIdleTimer } from 'react-idle-timer'
import { useNavigate } from 'react-router-dom'
import { IG_HANDLE_INPUT_ROUTE, IG_HELPDESK_URL } from '../../constants/constants'
import { getIntendedPath } from '../../redux-stores/store'

interface IGHandleVerificationData {
    is_verified: boolean,
    text: string,
    handle: string,
    receiver: string,
    cta_url: string
}

const ConnectIGHandleVerify: React.FC = () => {

    const [verificationData, setVerificationData] = useState<IGHandleVerificationData | null>(null);
    const [loading, setLoading] = useState(true);
    const [verifying, setVerifying] = useState(false);

    const navigate = useNavigate();

    const fetchHandle = async (showLoading = true) => {
        try {
            if (showLoading)
                setLoading(true);
            const response = await fetchIGHandleVerificationStatus();
            if (response.verification) {
                setVerificationData(response.verification);
            }
        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        fetchHandle();
    }, [])


    const verify = () => {
        if (!verificationData?.cta_url) return;

        setVerifying(true);
        setTimeout(() => {
            window.open(verificationData.cta_url, '_blank');
        }, 500)
    }

    useEffect(() => {
        if (verificationData?.is_verified) {
            window.location.href = getIntendedPath();
            // navigate(getIntendedPath());
        }
    }, [verificationData?.is_verified])

    useEffect(() => {
        if (verificationData && !verificationData.handle) {
            navigate(IG_HANDLE_INPUT_ROUTE);
        }
    }, [verificationData])

    useIdleTimer({
        throttle: 10000,
        onAction: () => {
            fetchHandle(false);
        }
    });

    return (
        <MobileView>
            <AuthLayout
                action={
                    <a href="https://api.whatsapp.com/send?phone=+919266391960&text=Hi, I need help." target="_blank" rel="noreferrer" className="skip-and-verify d-flex align-items-center">
                        <span className='me-1'>
                            <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M1.33398 8.58298C1.33398 4.85541 4.31874 1.83362 8.00062 1.83362C11.6825 1.83362 14.6672 4.85541 14.6672 8.58298L14.6673 12.0786C14.6675 12.6232 14.6676 12.9967 14.5719 13.3246C14.3847 13.9657 13.937 14.4961 13.3406 14.7833C13.0357 14.9302 12.6713 14.9883 12.1399 15.073L12.0532 15.0869C11.8643 15.1171 11.7028 15.1429 11.5688 15.1562C11.4294 15.1701 11.2872 15.1743 11.1418 15.1453C10.6634 15.05 10.2689 14.7087 10.1012 14.2451C10.0502 14.1042 10.0322 13.9614 10.024 13.8198C10.0161 13.6838 10.0161 13.5183 10.0161 13.3246L10.0161 10.543C10.0157 10.2594 10.0154 10.0153 10.0803 9.80626C10.2288 9.32803 10.6165 8.96529 11.0991 8.85307C11.31 8.80402 11.5504 8.82353 11.8296 8.8462L11.8918 8.85122L11.965 8.85705C12.4875 8.89863 12.8449 8.92707 13.1484 9.04069C13.3616 9.12054 13.5594 9.23048 13.737 9.36536V8.58298C13.737 5.37554 11.1687 2.77539 8.00062 2.77539C4.83249 2.77539 2.26421 5.37554 2.26421 8.58298V9.36536C2.44182 9.23048 2.6396 9.12054 2.85284 9.04069C3.15629 8.92707 3.51375 8.89863 4.03622 8.85705L4.10944 8.85122L4.17159 8.8462C4.45088 8.82353 4.69119 8.80402 4.90214 8.85307C5.38473 8.96529 5.77243 9.32803 5.92091 9.80626C5.98581 10.0153 5.98552 10.2594 5.98517 10.543L5.98512 13.3246C5.98513 13.5183 5.98513 13.6838 5.97723 13.8198C5.96901 13.9614 5.95099 14.1042 5.90002 14.2451C5.73234 14.7087 5.33781 15.05 4.8594 15.1453C4.71399 15.1743 4.57182 15.1701 4.43244 15.1562C4.29846 15.1429 4.13698 15.1171 3.948 15.0869L3.86136 15.073C3.32997 14.9883 2.96557 14.9302 2.66059 14.7833C2.06421 14.4961 1.61657 13.9657 1.42937 13.3246C1.35043 13.0542 1.33668 12.7528 1.33439 12.3501L1.33398 12.2205V8.58298Z" fill="white" />
                            </svg>
                        </span>
                        Help
                    </a>
                }
                leftAction={
                    <a href="/logout" className="skip-and-verify"><i className="fa-solid fa-right-from-bracket me-1"></i>Logout</a>
                }
            >
                {
                    loading ? (
                        <div className="position-relative h-100 auth-content-inner">
                            <div className="loading d-flex justify-content-center h-100 align-items-center flex-column gap-2">
                                <div className="spinner-border color-blue-dark" role="status">
                                </div>
                                Loading...
                            </div>
                        </div>
                    ) : (
                        <div className="position-relative h-100 auth-content-inner">
                            <div className="d-flex justify-content-between align-items-center gap-2">
                                <h4 className='social-handle-verification-heading'>Genuine Influencers. Genuine Brands</h4>
                            </div>
                            <span className='social-handle-verification-text'>Only verified influencers can apply to brand collabs which helps us keep Influns genuine.</span>
                            <div className="social-handle-verification-steps-card">
                                <h6 className="social-handle-verification-steps-heading">How to Verify Yourself</h6>
                                <ol className="social-handle-verification-steps">
                                    <li className='social-handle-verification-step'>
                                        DM <span className='handle' onClick={verify}>@{verificationData?.receiver}</span> on <span className='bold-text'>instagram</span>.
                                    </li>
                                    <li className='social-handle-verification-step'>
                                        Make sure you <span className="bold-text">DM</span> with <span className='handle'>@{verificationData?.handle}</span>
                                        <span className='cursor-pointer ms-1' onClick={() => navigate(IG_HANDLE_INPUT_ROUTE)}>
                                            <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M5.95975 11.2439C6.14536 11.0991 6.31372 10.9308 6.65038 10.5941L10.9646 6.27985C10.3775 6.03546 9.68201 5.63403 9.02429 4.97631C8.36647 4.31849 7.96501 3.62292 7.72064 3.03569L3.40631 7.35002L3.40627 7.35006C3.06962 7.68671 2.90128 7.85505 2.75652 8.04065C2.58574 8.2596 2.43932 8.49651 2.31986 8.74718C2.21859 8.95968 2.1433 9.18552 1.99274 9.63723L1.19875 12.0192C1.12466 12.2415 1.18251 12.4865 1.34819 12.6522C1.51388 12.8179 1.75895 12.8757 1.98123 12.8017L4.36318 12.0077C4.81487 11.8571 5.04073 11.7818 5.25323 11.6805C5.5039 11.5611 5.7408 11.4147 5.95975 11.2439Z" fill="#007AFF" />
                                                <path d="M12.1618 5.0827C13.0576 4.18687 13.0576 2.73445 12.1618 1.83862C11.266 0.942791 9.81354 0.942791 8.91771 1.83862L8.40027 2.35606C8.40735 2.37745 8.4147 2.39915 8.42233 2.42112C8.61199 2.96779 8.96983 3.68442 9.64301 4.35759C10.3162 5.03077 11.0328 5.38861 11.5795 5.57827C11.6014 5.58586 11.6229 5.59318 11.6442 5.60023L12.1618 5.0827Z" fill="#007AFF" />
                                            </svg>
                                        </span>
                                    </li>
                                    <li className='social-handle-verification-step'>
                                        We’ll verify it in seconds and notify you here. Then you’re all set to apply to brand collabs.
                                    </li>
                                </ol>
                            </div>
                            {/* <div className="copy-text">
                                <span className="copy-text-desc">Copy your WhatsApp number</span>
                                <div className="d-flex align-items-center gap-2">
                                    <h3 className="text-to-be-copied m-0">{verificationData?.text}</h3>
                                    <button onClick={() => copyToClipboard(verificationData?.text ?? '', 'Copied to your clipboard!')} className="copy-text-button">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                            <path d="M4 7.33337C4 5.44776 4 4.50495 4.58579 3.91916C5.17157 3.33337 6.11438 3.33337 8 3.33337H10C11.8856 3.33337 12.8284 3.33337 13.4142 3.91916C14 4.50495 14 5.44776 14 7.33337V10.6667C14 12.5523 14 13.4951 13.4142 14.0809C12.8284 14.6667 11.8856 14.6667 10 14.6667H8C6.11438 14.6667 5.17157 14.6667 4.58579 14.0809C4 13.4951 4 12.5523 4 10.6667V7.33337Z" stroke="#007AFF" />
                                            <path d="M4 12.6667C2.89543 12.6667 2 11.7713 2 10.6667V6.66671C2 4.15255 2 2.89547 2.78105 2.11442C3.5621 1.33337 4.81918 1.33337 7.33333 1.33337H10C11.1046 1.33337 12 2.2288 12 3.33337" stroke="#007AFF" />
                                        </svg>
                                    </button>
                                </div>
                            </div> */}
                            <div className="position-absolute w-100 bottom-1">
                                <button
                                    onClick={verify}
                                    className="btn btn-primary w-100">DM us on Instagram</button>
                            </div>
                        </div>
                    )
                }

                <div id="downloading-screen" className={`menu ${verifying ? 'menu-active' : ''} menu-box-modal rounded-m`}>
                    <div className="text-center p-5 d-flex flex-column align-items-center justify-content-center">
                        <h5>Verifying...</h5>
                        <div className="spinner-border text-primary mt-3" role="status" style={{ width: '2rem', height: '2rem' }}>
                            <span className="visually-hidden">Loading...</span>
                        </div>
                    </div>
                </div>
                {
                (verifying) && <div className={`menu-hider menu-active`} onClick={() => {
                    setVerifying(false)
                }}></div>
            }
            </AuthLayout>
        </MobileView>
    )
}

export default ifAuthenticated(ConnectIGHandleVerify)